import Svg, { Path } from 'react-native-svg';
import { CATEGORY_GLYPH_PATHS } from '../../theme';
import type { PostCategory } from '../../types';

interface CategoryPinGlyphProps {
  category: PostCategory;
  size: number;
  color: string;
  strokeWidth?: number;
}

/**
 * Bare progress/risk glyph (check or exclamation) for the inside of a
 * colored map pin dot — the dot itself acts as the circle, so this renders
 * just the stroked inner mark. Shared source of `CATEGORY_GLYPH_PATHS` keeps
 * native (`Map.native.tsx`) and web (`useMarkerLayer.web.ts`,
 * `MapPostHoverCard.web.tsx`) pixel-identical.
 */
export function CategoryPinGlyph({
  category,
  size,
  color,
  strokeWidth = 3,
}: CategoryPinGlyphProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {CATEGORY_GLYPH_PATHS[category].map((d) => (
        <Path
          key={d}
          d={d}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </Svg>
  );
}
